const local = {
  requireLogin: false,
  apiBaseUrl: "http://localhost:7071/api",
  keys: {
    getEventsKey: "",
    getCustomerByEmailKey: "",
    getCustomerLinesKey: "",
    putCustomerLinesKey: "",
    createCustomerKey: "",
    createCustomerLinesKey: "",
    getTimeSlotsKey: "",
  },
};

const dev = {
  requireLogin: true,
  apiBaseUrl: "https://environz-api-dev.azurewebsites.net/API/",
  keys: {
    getEventsKey: "bO3ppF90cx6HCLd/ziQKUaubZg339OvyiEjS6pBaHwEIRfMMTjlVSw==",
    getTimeSlotsKey: "jt-vcWeupLy4qu0rOoblWOvNPBjXnWZZevSgFYRrJd4-AzFuZDnNPQ==",
    getCustomerByEmailKey:
      "JWwYJxJLdKAnT0ZYPqt7Mggva8m8qOdxwOfvMI399ZPxAzFujpCDeQ==",
    getCustomerLinesKey:
      "79t4l4MMLuLqfJnrYAYZkmc9qRa9Z7BaNlKZpMyk0DPcFPqsX61Udw==",
    putCustomerLinesKey:
      "-mIgGnCyGZEyXaPTKpEkmKpbsiS86l60UYTlSKfUXWkpAzFu1XXzug==",
    createCustomerKey:
      "jwZX1VrPhhg5Be9A1E43kUCprfLn/p6FI6fbOIwc2gWYRdX72bKxDw==",
    createCustomerLinesKey:
      "TQ6OXaFEz9d0fHqXrGqPQGsirVM5EwBr5zndaz6AuryWn/ouRYgGsA==",
  },
};

const prod = {
  requireLogin: false,
  apiBaseUrl: "https://environz-api.azurewebsites.net/API/",
  keys: {
    getEventsKey: "AadB7wp9HMM5RJiLZHOjFwWq/y87N6NftKkZ2ogt8UXnpswdBUpn2g==",
    getCustomerByEmailKey:
      "HwQGZkqGRbJGLIC40t5020hWFYuDgp2lF5WL18WjPmdNAzFufneKmQ==",
    getCustomerLinesKey:
      "jseTdX0aZmgCbc9ayplR4BaAMV29rwxqByz618VXxCVPUxba1qgEoA==",
    putCustomerLinesKey:
      "HeLlWjvaGwjjDAp1LK6IhwyFmgkiJN1GvsT0ZANY4Z5GAzFulfKXQg==",
    getTimeSlotsKey: "Iw1MD399mjRNu5Nt9jHC3rACnQpxHib8jJ6EAsvmbX5UAzFupmJylw==",
    createCustomerKey:
      "joFysf0clWknfl1qTY9KREakvFLIqteWFAUdMf8oGUxqlpSUIipCqg==",
    createCustomerLinesKey:
      "FF14lxUVbyBd/PmP1NpdQGAbIqTAzwB7JthtfO3fCXtZxGJOxJ7gDg==",
  },
};

const envConfig =
  process.env.REACT_APP_ENVIRONMENT === "prod"
    ? prod
    : process.env.REACT_APP_ENVIRONMENT === "local"
      ? local
      : dev;

export default envConfig;
